{
    "Domain": "Domain:",
    "EmailServerConnectivity": "E-mail Server Connectivity",
    "CustomDownloadLinks": "Custom Download Links",
    "ServerIpAddress": "Server IP Address:",
    "TcpPort": "TCP Port:",
    "CommunicationActive": "Communication Active:",
    "FromAddressEmail": "From Address (E-mail):",
    "FromAddressName": "From Address (Name):",
    "CompanyName": "Company Name:",
    "MSTeamsAppDownloadLinkURLName": "MS Teams App Download URL:",
    "CXIClientDownloadLinkWindowsUrlName": "CXI Client (Windows) URL:",
    "CXIClientDownloadLinkMacUrlName": "CXI Client (Mac) URL:",
    "SearchAndCallDownloadLinkURLName": "Search and Call URL:",
    "AccessCodes": "Access Codes",
    "CXIAccessCode": "CXI Access Code:",
    "UseAuthentication": "Use Authentication:",
    "AuthenticationSettings": "Authentication Settings",
    "NAME": "DomainProfile",
    "DomainProfile_ButtonHelpLabel": "Help?",
    "DomainProfile_ButtonSubmitLabel": "OK",
    "DomainProfile_ButtonCancelLabel": "Cancel",
    "DomainProfile_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
    "DomainProfile_PromptConfirm": "Yes",
    "DomainProfile_PromptCancel": "Cancel",
    "DomainProfile_Username": "Username:",
    "DomainProfile_Password": "Password:",
    "DomainProfile_PasswordPlaceholder": "••••••"
}
